import { Button } from "@loot-os/ui/components/button";
import * as Sentry from "@sentry/react";
import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

/** Root route errorComponent: reports the render failure and offers one retry. */
export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter();
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-3 text-sm">
      <p className="text-muted-foreground">Something went wrong on this page.</p>
      <Button onClick={() => router.invalidate()}>Try again</Button>
    </div>
  );
}
